<template>
  <section class="mainHeader">
    <div class="page">
      <div class="card">
        <slot/>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SectionHeader'
})
</script>
